import { Component, Input, OnInit } from '@angular/core';
import { UserService } from 'app/Shared/Services/user.service';
import { CaisServiceService } from '../../cais-service.service';
import { CaisExceptionServiceService } from '../../exceptions/cais-exception-service.service';
import { CommonModule, NgClass, LowerCasePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatListItem } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TableModule } from 'primeng/table';
import { MultiSelectModule } from 'primeng/multiselect';
import { Select } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

@Component({
    selector: 'app-fdid-record-details',
    templateUrl: './fdid-record-details.component.html',
    imports: [CommonModule, NgClass, LowerCasePipe, FormsModule, ReactiveFormsModule,
        Select, DatePickerModule, TableModule, MatTooltipModule, MatListItem, MatDividerModule,
        MultiSelectModule, ToggleSwitchModule],
    providers: [CaisExceptionServiceService, UserService],
    styleUrls: ['./fdid-record-details.component.scss']
})
export class FdidRecordDetailsComponent implements OnInit {

  @Input('fdidScreenDataDetails') fdidScreenDataDetails: any;
  @Input('editScreenNegotiatedFields') editScreenNegotiatedFields: any;
  @Input('ExceptionalFDIDScreenFields') ExceptionalFDIDScreenFields: any;
  @Input('editDisabledFields') editDisabledFields: any;
  constructor(public caisExceptionServiceService: CaisExceptionServiceService,
    public caisServiceService: CaisServiceService,
    public userService:UserService) {
  }

  ngOnInit() {
  }

}
